import React, { useRef } from 'react';
import { Outlet } from 'react-router-dom'; // If using React Router
import Header from '../components/Header';
import Footer from '../components/Footer';


const MainLayout = () => {	
	return (
    <>
		<Header  />		
		<main>
			<Outlet /> {/* Renders nested routes/components */}
		</main>
		<Footer />
    </>
	);
};

export default MainLayout;